import Error404 from '@its/components/lib/Presentational components/Pages/Error404/Error404';
import GoogleLogin from '@its/components/lib/Presentational components/Auth/GoogleLogin/GoogleLogin';
import AuthComplete from '@its/components/lib/Presentational components/Auth/AuthComplete/AuthComplete';
import UserRequest from './Requests/UserRequest';
import DisplayList from './Display/DisplayList';
import DisplayModification from './Display/DisplayModification';
import DisplayAddition from './Display/DisplayAddition';
import WysiwygList from './Display/WysiwygList';
import TimerList from './Timer/TimerList';
import TimerAddition from './Timer/TimerAddition';
import { Timer } from './Timer/Timer';
import DepartmentList from './Department/DepartmentList';
import DepartmentAddition from './Department/DepartmentAddition';
import { Department } from './Department/Department';
import TemplateList from './Template/TemplateList';
import TemplateAddition from './Template/TemplateAddition';
import Template from './Template/Template';
import Map from './Template/Map/Map';
import MapAddition from './Template/Map/MapAddition';
import Help from './Util/Help';
import Settings from './Util/Settings';

// TODO : creare funzioni per lista, dettagli e modifica automatici

export default [
  {
    path: '/',
    component: UserRequest,
    indexRoute: { component: DisplayList },
    childRoutes: [
      { path: '/displays', component: DisplayList },
      { path: '/displays/preview', component: WysiwygList },
      { path: '/display/add', component: DisplayAddition },
      { path: '/display', component: DisplayModification },
      { path: '/timers', component: TimerList },
      { path: '/timer/add', component: TimerAddition },
      { path: '/timer', component: Timer },
      { path: '/departments', component: DepartmentList },
      { path: '/department/add', component: DepartmentAddition },
      { path: '/department', component: Department },
      { path: '/templates', component: TemplateList },
      { path: '/template/add', component: TemplateAddition },
      { path: '/template', component: Template },
      { path: '/template/map/add', component: MapAddition },
      { path: '/template/map', component: Map },
      { path: '/help', component: Help },
      { path: '/settings', component: Settings },
    ],
  },
  { path: '/login', component: GoogleLogin },
  { path: '/authComplete', component: AuthComplete },
  { path: '*', component: Error404 },
];



/** WEBPACK FOOTER **
 ** ./src/routes/index.js
 **/